import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { CedProductModel } from './models/ced-product.model';

@Injectable({
  providedIn: 'root'
})
export class CedProductService extends GenericService<CedProductModel> {
  constructor(private http: HttpClient) {
    super(http, '/CedProduct/')
}
private generateHeaders() {
  return {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    }),
  };
}

getAllCedProducts(){
  return this.http.get(this.url ,this.generateHeaders());
}

addCedProduct(cedProduct){
  return this.http.post(this.url ,cedProduct,this.generateHeaders());
}

getProductByClassification(){
    return this.http.get(
      this.url + "GetProductByClassification" ,
      this.generateHeaders()
    );
  }

  getActiveCedProducts(){
    return this.http.get(this.url + "GetActiveCedProducts", this.generateHeaders());
  }

  AddByProductClassification(saleProduct){
    return this.http.post(
      this.url + "AddByProductClassification" ,saleProduct,
      this.generateHeaders()
    );
  }
}